var cookies = require('cookies-js');

angular.module('app.directives').directive('consent', function ($location) {
  return {
    scope: {},
    template: require('./template.pug'),
    controller: function ($scope) {
      $scope.hasConsent = cookies.get('consent');
      $scope.host = $location.host();
      $scope.policyUrl = window.conf.cms_url + 'privacy-policy-cookie-policy/';
      $scope.giveConsent = function () {
        cookies.set('consent', true, {
          expires: Infinity,
          domain: window.conf.cookie_domain,
          httpOnly: false,
          sameSite: window.conf.cookie_is_secure ? 'strict' : 'lax',
          secure: window.conf.cookie_is_secure,
        });
        $scope.hasConsent = true;
      };
    },
  };
});
